// Build-time stand-in for the edition UI module. SaaS builds alias
// '@optops-hpc-ui' HERE (see craco.config.js), so none of the edition code —
// or its route strings — is ever bundled. Keep every identifier and string in
// this file neutral: this module DOES ship in the SaaS bundle (comments are
// stripped by the production build, identifiers are mangled, but don't rely
// on it — write nothing edition-specific below).

export const editionEnabled = false;
export const editionHome = null;
export const editionRoutes = () => null;
